import { Pill, PillKind } from "./ui/pill";

// Shared status/priority/bemiddeling badges for vacatures, so every page shows
// the same label and colour for the same backend value.

export const STATUS_LABELS: Record<string, string> = {
  open:     "Open",
  hold:     "On hold",
  gesloten: "Gesloten",
};

export const PRIORITY_LABELS: Record<string, string> = {
  hoog:    "Hoog",
  normaal: "Normaal",
  laag:    "Laag",
};

export const BEMIDDELING_LABELS: Record<string, string> = {
  geen:           "Geen",
  in_bemiddeling: "In bemiddeling",
  shortlisted:    "Shortlist",
  geplaatst:      "Geplaatst",
};

// Values offered in the bemiddeling picker. "shortlisted"/"geplaatst" stay in
// BEMIDDELING_LABELS so existing vacatures with those values still render.
export const BEMIDDELING_OPTIONS = ["geen", "in_bemiddeling"] as const;

export function statusPillKind(s: string): PillKind {
  if (s === "hold") return "hold";
  if (s === "gesloten") return "closed";
  return "open";
}

export function priorityPillKind(p: string): PillKind {
  if (p === "hoog") return "prio-high";
  if (p === "laag") return "prio-low";
  return "prio-med";
}

export function bemiddelingPillKind(b: string): PillKind {
  if (b === "geplaatst") return "med-done";
  if (b === "in_bemiddeling" || b === "shortlisted") return "med-active";
  return "med-none";
}

export function StatusBadge({ value, className }: { value: string; className?: string }) {
  return <Pill kind={statusPillKind(value)} className={className}>{STATUS_LABELS[value] ?? value}</Pill>;
}

export function PriorityBadge({ value, className }: { value: string; className?: string }) {
  return <Pill kind={priorityPillKind(value)} className={className}>{PRIORITY_LABELS[value] ?? value}</Pill>;
}

export function BemiddelingBadge({ value, className }: { value: string; className?: string }) {
  return <Pill kind={bemiddelingPillKind(value)} className={className}>{BEMIDDELING_LABELS[value] ?? value}</Pill>;
}
